import { createAction, props } from '@ngrx/store';
import { IOtpRequest, IOtpResponse } from '../../../core/models/otp.model';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';

export const loadLoginConfirmRequest = createAction('[LoginConfirm] Load LoginConfirms', props<{ request: IOtpRequest }>());

export const loadLoginConfirmSuccess = createAction('[LoginConfirm] Load LoginConfirms Success', props<{ response: IOtpResponse }>());

export const loadLoginConfirmFailure = createAction(
  '[LoginConfirm] Load LoginConfirms Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

export const clearLoginConfirmSuccess = createAction('[LoginConfirm] Clear LoginConfirms Success');
